module.exports = __webpack_public_path__ + "img/ptt.804e9c61.png";